/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';
import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';

import { apiConfig } from '@pages/OrganizationProfile/config/api.config';
import { revokeCredentialConfig } from '@pages/HolderPage/config/revokeCredential.config';
import { REVOKE_CREDENTIAL } from '@pages/HolderPage/api/graphql';
import { notificationHoldersConfig } from '../../config/notifications.config';

const getWhoamiSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IResendCredentialsPluginMethods extends IPluginMethodMap {
  getResendCredentials(args?: any): Promise<any>;
}

export class ResendCredentialsPlugin implements IAgentPlugin {
  readonly methods: IResendCredentialsPluginMethods;
  constructor() {
    this.methods = {
      getResendCredentials: this.getResendCredentials.bind(this),
    };
  }

  async getResendCredentials(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    await this.findCapsules();
    return {
      //products: this.formatProducts(this.products),
    };
  }
  //Graphql Query example
  async findCapsules(args?: any) {
    //try {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    const token = getWhoamiSrv()?.getToken();
    // const token = null;
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        let _thr =
          args?.sendToEmail && args?.sendToWallet
            ? 'BOTH'
            : args?.sendToEmail
            ? 'EMAIL'
            : args?.sendToWallet
            ? 'WALLET'
            : null;
        const res = await client
          .mutation(REVOKE_CREDENTIAL, {
            input: {
              id: args?.id,
              thr: _thr,
            },
          })
          .toPromise();
        if (res?.data?.resendCredential?.message) {
          return {
            notification: notificationHoldersConfig?.resendCredential,
          };
        }
      }
    } catch (err: any) {
      // log.log('result of update profile=', res?.data?.capsules);
      log.error('error in update profile=', err?.message);
      throw err;
    }
  }

  // private formatProducts(products: any) {
  //   return products.map((product: any) => product);
  // }
}
